export const categoriesRoutes = {
	categories: (query: string) => `/categories/${query ? `?${query}` : ''}`,
	category: (id: string) => `/categories/${id}/`,
	categoryHistory: (id: string) => `/categories/${id}/history/`,
	categoriesDelete: '/categories/bulk_delete/'
} as const
